

import { Card, CardContent, LinearProgress, Grid, Box, Button, Link, makeStyles, Paper, Typography, FormControlLabel, Select, MenuItem, TextField, Checkbox, NativeSelect, OutlinedInput, FormControl, InputLabel, List, ListItem, Table, TableRow, TableCell, Collapse, Alert, AlertTitle, Tooltip, IconButton } from '@mui/material';
import React, { Component, useEffect, useState } from 'react'
import { Field, Form, Formik, FormikProvider, useFormik } from 'formik';

import * as Yup from "yup";
import api from '../../../redux/features/auth/axiosAuthHelper';
import dayjs from 'dayjs';
import assets from '../../../assets'
import colorConfigs from '../../../configs/colorConfigs';
import ResultDetailGraph from '../graphs/ResultDetailGraph';
import { useTheme } from '@mui/material/styles';
import { ResultDetailEditField, TCRatioField, ImageField, TScoreField, CScoreField, CPeakField, TPeakField, FormVisualResultsField, NotesField, TextAdornmentReadOnlyField, TextAdornmentNoStatusReadOnlyField, FeedbackReadOnlyField } from '../fields/fields';
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import RareButton from '../buttons/RareButton';
import { Navigate } from 'react-router-dom';
import { BatchTextAdornmentReadOnlyField, OrganisationTextAdornmentReadOnlyField, UserTextAdornmentReadOnlyField } from '../fields/resultDetailFields';
import { Link as RouterLink } from 'react-router-dom';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

interface FeedbackDetailProps {
    feedback_id: any;
    handleBackButton: () => void;
}


const FeedbackDetailCard: React.FC<FeedbackDetailProps> = ({ feedback_id, handleBackButton }) => {

    const [testImage, setTestImage] = useState<any>()
    const [stripImages, setStripImages] = useState<any[]>([])
    const [lines, setLines] = useState<any[]>([])
    const [feedback, setFeedback] = useState<any>(null)
    const [user, setUser] = useState<any>("")
    const [errors, setErrors] = useState<string | null>(null);
    const authData = useSelector((state: RootState) => state.auth);

    const validationSchema = () => {
        return Yup.object().shape({
        });
    }

    useEffect(() => {
        const fetchFeedback = async () => {
            try {
                const url = `feedback/${feedback_id}`

                const response = await api.get(url, {
                    headers: {
                        'Authorization': `Bearer ${authData.access}`
                    }
                });
                setFeedback(response.data);
                console.log("feedback", response.data)

                try {
                    const url = `users/${response?.data?.user_id}`

                    const res = await api.get(url, {
                        headers: {
                            'Authorization': `Bearer ${authData.access}`
                        }
                    });
                    setUser(res.data);
                    console.log("user", res.data)

                } catch (error) {
                    console.log(error)
                    console.log(`Cannot find User with id ${feedback.user_id}`)
                }

            } catch (error) {
                console.error('Error fetching result', error);
                setErrors(`No Feedback found with ID ${feedback_id}`)
                setTimeout(() => {
                    handleBackButton()
                }, 4000);
            }
        };
        fetchFeedback()
    }, [feedback_id])

    const formik = useFormik({
        validateOnChange: false,
        validateOnBlur: false,
        initialValues: {

            // Feedback Data
            id: '',
            timestamp: '',
            test_feedback: '',
            test_feedback_notes: '',
            test_feedback_image: '',
            reader_feedback: '',
            reader_feedback_notes: '',
            reader_feedback_image: '',
            test_type: '',
            batch_id: '',
            lot_number: '',
            longitude: '',
            latitude: '',
            device_platform: '',
            device_manufacturer: '',
            device_model: '',
            device_uuid: '',
            os_version: '',
            app_version: '',
            app_build: '',
            organisation_id: '',
            organisation_name: '',
            user_id: '',

            // User Data
            fb_user_id: '',
            fb_user_first_name: '',
            fb_user_last_name: '',
            fb_user_email: '',
            fb_user_is_active: '',
            fb_user_organisation_id: '',
            fb_user_organisation_name: '',
            fb_user_user_type: '',
        },
        validationSchema,
        onSubmit: (values) => {
        },
    });

    useEffect(() => {
        // Set User Data
        if (user) {
            formik.setFieldValue('fb_user_id', user.id);
            formik.setFieldValue('fb_user_first_name', user.first_name);
            formik.setFieldValue('fb_user_last_name', user.last_name);
            formik.setFieldValue('fb_user_email', user.email);
            formik.setFieldValue('fb_user_is_active', user.is_active);
            formik.setFieldValue('fb_user_organisation_id', user.organisation);
            formik.setFieldValue('fb_user_organisation_name', user.organisation_name);
            formik.setFieldValue('fb_user_user_type', user.user_type);
        }
    }, [user]);

    useEffect(() => {
        // Set Feedback Data
        if (feedback) {
            formik.setFieldValue('id', feedback.id);
            formik.setFieldValue('timestamp', dayjs(feedback.timestamp).format('YYYY-MM-DD HH:mm:ss'));
            formik.setFieldValue('test_feedback', feedback.test_feedback);
            formik.setFieldValue('test_feedback_notes', feedback.test_feedback_notes);
            formik.setFieldValue('reader_feedback', feedback.reader_feedback);
            formik.setFieldValue('reader_feedback_notes', feedback.reader_feedback_notes);
            formik.setFieldValue('test_type', feedback.test_type);
            formik.setFieldValue('batch_id', feedback.batch_id);
            formik.setFieldValue('lot_number', feedback.lot_number);
            formik.setFieldValue('longitude', feedback.latitude);
            formik.setFieldValue('latitude', feedback.result_uuid);
            formik.setFieldValue('device_platform', feedback.device_platform);
            formik.setFieldValue('device_manufacturer', feedback.device_manufacturer);
            formik.setFieldValue('device_model', feedback.device_model);
            formik.setFieldValue('device_uuid', feedback.device_uuid);
            formik.setFieldValue('os_version', feedback.os_version);
            formik.setFieldValue('app_version', feedback.app_version);
            formik.setFieldValue('app_build', feedback.app_build);
            formik.setFieldValue('organisation_id', feedback.organisation_id);
            formik.setFieldValue('organisation_name', feedback.organisation_name);
            formik.setFieldValue('user_id', feedback.user_id);

            const feedbackImage: Record<string, string> = {
                "Good": assets.images.good,
                "Ok": assets.images.ok,
                "Bad": assets.images.bad,
            }

            formik.setFieldValue('test_feedback_image', feedbackImage[`${feedback.test_feedback}`] || assets.images.good);

            formik.setFieldValue('reader_feedback_image', feedbackImage[`${feedback.reader_feedback}` || assets.images.good]);

        }
    }, [feedback]);


    return !feedback_id ? (
        <Navigate to={"/feedback"} />
    ) : !feedback ? (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ width: "100%" }}>
                <LinearProgress />
            </Box>
            {errors && (
                <Alert severity="error" style={{ width: "100%%" }}>
                    <AlertTitle>Error</AlertTitle>
                    {errors}
                </Alert>
            )}
        </Box>
    ) : (
        <FormikProvider value={formik}>
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 3,
                    p: 2,
                }}
            >

                {/* Section 1 – on large screens, this is in the middle; on md, it’s full width on top */}
                <Box
                    sx={{
                        order: { xs: 1, md: 1, lg: 2 },
                        flex: { xs: '1 1 100%', md: '1 1 100%', lg: '1 1 610px' },
                    }}
                >
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                        <Card sx={{ boxShadow: 10, height: '100%', width: '100%', display: 'flex', flexDirection: 'column' }}>
                            <Box sx={{ display: 'flex' }}>
                                <Box sx={{ height: '100%', background: colorConfigs.tables.headBg, display: 'flex', alignItems: 'center', borderBottomRightRadius: 3 }}>
                                    <Typography sx={{ px: 2, py: 0.5, color: '#fff', fontWeight: 'bold', fontSize: '20px' }}>Reader Feedback</Typography>
                                </Box>
                            </Box>
                            <Box sx={{ p: 2 }}>
                                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                                    <Box
                                        component="img"
                                        sx={{
                                            width: '40px',
                                            height: '40px',
                                        }}
                                        alt="Reader Feedback"
                                        src={formik.values.reader_feedback_image}
                                    />
                                    <Field name="reader_feedback" type="text" className="form-control" label="Reader Feedback" component={ResultDetailEditField} />
                                </Box>
                                <Field name="reader_feedback_notes" type="text" className="form-control" label="Reader Notes" rows={4} component={NotesField} />
                            </Box>
                        </Card>
                        <Card sx={{ boxShadow: 10, height: '100%', width: '100%', display: 'flex', flexDirection: 'column' }}>
                            <Box sx={{ display: 'flex' }}>
                                <Box sx={{ height: '100%', background: colorConfigs.tables.headBg, display: 'flex', alignItems: 'center', borderBottomRightRadius: 3 }}>
                                    <Typography sx={{ px: 2, py: 0.5, color: '#fff', fontWeight: 'bold', fontSize: '20px' }}>Test Feedback</Typography>
                                </Box>
                            </Box>
                            <Box sx={{ p: 2 }}>
                                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                                    <Box
                                        component="img"
                                        sx={{
                                            width: '40px',
                                            height: '40px',
                                        }}
                                        alt="Test Feedback"
                                        src={formik.values.test_feedback_image}
                                    />
                                    <Field name="test_feedback" type="text" className="form-control" label="Test Feedback" component={ResultDetailEditField} />
                                </Box>
                                <Field name="test_feedback_notes" type="text" className="form-control" label="Test Notes" rows={4} component={NotesField} />
                            </Box>
                        </Card>
                    </Box>

                </Box>

                {/* Section 2 – on lg: first in the row; on md: second row (left); on xs/sm: full width */}
                <Box
                    sx={{
                        order: { xs: 2, md: 2, lg: 1 },
                        flex: {
                            xs: '1 1 100%',
                            md: '1 1 calc(50% - 1.5rem)', // 50% each minus half the gap
                            lg: '0 1 366px',
                        },
                    }}
                >
                    <Card sx={{ boxShadow: 10, height: '100%', width: '100%', display: 'flex', flexDirection: 'column' }}>
                        <Box sx={{ display: 'flex' }}>
                            <Box sx={{ height: '100%', background: colorConfigs.tables.headBg, display: 'flex', alignItems: 'center', borderBottomRightRadius: 3 }}>
                                <Typography sx={{ px: 2, py: 0.5, color: '#fff', fontWeight: 'bold', fontSize: '20px' }}>Feedback Details</Typography>
                            </Box>
                        </Box>
                        <Box sx={{ p: 2 }}>
                            <Field name="id" type="text" className="form-control" label="Feedback ID" component={ResultDetailEditField} />
                            <Field name="timestamp" type="text" className="form-control" label="Timestamp" component={ResultDetailEditField} />
                            <Field name="test_type" type="text" className="form-control" label="Test Type" component={ResultDetailEditField} />

                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Field name="fb_user_email" status={formik.values.fb_user_is_active} id={formik.values.fb_user_id} type="text" className="form-control" label="Created By" component={UserTextAdornmentReadOnlyField} />
                                <Tooltip
                                    arrow
                                    placement="top"
                                    title="View User"
                                >
                                    <IconButton
                                        component={RouterLink}
                                        to={`/users/${formik?.values?.fb_user_id}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        sx={{ transition: 'transform 0.3s ease', p: 1, mt: 1 }}
                                    >
                                        <VisibilityOutlinedIcon sx={{ color: colorConfigs.sidebar.color }} />
                                    </IconButton>
                                </Tooltip>
                            </Box>

                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Field name="organisation_name" id={formik.values.organisation_id} type="text" className="form-control" label="Organisation" component={OrganisationTextAdornmentReadOnlyField} />
                                <Tooltip
                                    arrow
                                    placement="top"
                                    title="View Organisation"
                                >
                                    <IconButton
                                        component={RouterLink}
                                        to={`/organisations/${formik?.values?.organisation_id}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        sx={{ transition: 'transform 0.3s ease', p: 1, mt: 1 }}
                                    >
                                        <VisibilityOutlinedIcon sx={{ color: colorConfigs.sidebar.color }} />
                                    </IconButton>
                                </Tooltip>
                            </Box>

                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Field name="lot_number" id={formik.values.batch_id} type="text" className="form-control" label="Lot / Batch" component={BatchTextAdornmentReadOnlyField} />
                                <Tooltip
                                    arrow
                                    placement="top"
                                    title="View Batch"
                                >
                                    <IconButton
                                        component={RouterLink}
                                        to={`/batches/${formik?.values?.batch_id}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        sx={{ transition: 'transform 0.3s ease', p: 1, mt: 1 }}
                                    >
                                        <VisibilityOutlinedIcon sx={{ color: colorConfigs.sidebar.color }} />
                                    </IconButton>
                                </Tooltip>
                            </Box>

                        </Box>
                    </Card>
                </Box>


                {/* Section 3 – on lg: third in the row; on md: second row (right); on xs/sm: full width */}
                <Box
                    sx={{
                        order: { xs: 3, md: 2, lg: 3 },
                        flex: {
                            xs: '1 1 100%',
                            md: '1 1 calc(50% - 1.5rem)',
                            lg: '0 1 366px',
                        },
                    }}
                >
                    <Card sx={{ boxShadow: 10, height: '100%', width: '100%', display: 'flex', flexDirection: 'column' }}>
                        <Box sx={{ display: 'flex' }}>
                            <Box sx={{ height: '100%', background: colorConfigs.tables.headBg, display: 'flex', alignItems: 'center', borderBottomRightRadius: 3 }}>
                                <Typography sx={{ px: 2, py: 0.5, color: '#fff', fontWeight: 'bold', fontSize: '20px' }}>Device Info</Typography>
                            </Box>
                        </Box>
                        <Box sx={{ p: 2 }}>
                            <Box sx={{ display: 'flex', gap: 1 }}>
                                <Field name="app_version" type="text" className="form-control" label="App Version" component={ResultDetailEditField} />
                                <Field name="app_build" type="text" className="form-control" label="App Build" component={ResultDetailEditField} />
                            </Box>
                            <Box sx={{ display: 'flex', gap: 1 }}>
                                <Field name="device_model" type="text" className="form-control" label="Device Model" component={ResultDetailEditField} />
                                <Field name="os_version" type="text" className="form-control" label="OS Version" component={ResultDetailEditField} />
                            </Box>
                        </Box>
                    </Card>
                </Box>
            </Box>
            {/* Section 4 – back button */}
            <Box
                sx={{
                    width: '100%',
                    ml: 1
                }}
            >
                <RareButton
                    onClick={() => handleBackButton()}
                    variant="outlined"
                    sx={{
                        position: "relative",
                        m: 1,
                    }}
                >
                    Back
                </RareButton>
            </Box>
        </FormikProvider>
    )
}

export default FeedbackDetailCard;